import React, {FC, useState} from 'react';
import {FiChevronDown, FiChevronUp} from 'react-icons/fi';

type UIDropdownProps = {
  name: string;
  children: any;
  icon?: object;
}

const UIDropdown: FC<UIDropdownProps> = ({name, children, icon}) => {
  const [toggled, setToggled] = useState(false);

  const toggleDropdown = () => setToggled(!toggled);

  return (
    <div className="flex flex-col relative w-full">
      <button
        className={
          'h-10 dropdown-border text-sm font-medium ' +
          'rounded-md flex lg:pl-2 items-center justify-between pl-4 ' +
          `${toggled && ' dropdown-open'} `
        }
        onClick={() => toggleDropdown()}
      >
        {icon && icon}
        {name}
        {!toggled ? (
          <FiChevronDown className='h-6 w-6 pr-1'/>
        ) : (
          <FiChevronUp className='h-6 w-6 pr-1'/>
        )}
      </button>
      <div className={
        `bg-white flex flex-col py-1 z-10 items-start w-full top-10 ` +
        `border border-gray-900 rounded-md mt-1 absolute overflow-y-scroll max-h-[400px] ` +
        `${!toggled && 'hidden'} `
      }>
        {children}
      </div>
    </div>
  );
};

export default UIDropdown;
